import $ from 'jquery';
import { decode } from '../../home24/core/base64';
import { rot13 } from '../../home24-shared/core/Utils';

let $scope = $('body');

export function run() {
    $scope.find('[data-def]').not('.def-processed').each(function () {
        var $this = $(this);

        try {
            $this.html(decode(rot13($this.attr('data-def'))));
            $this.addClass('def-processed');
        } catch (ignore) {}
    });
}

export function setScope(s) {
    $scope = s;
}

run();



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/deliveryTimes.js
 **/